import { GitBranch, Github } from "lucide-react";
import { Input } from "../../../ui/input";
import { Label } from "../../../ui/label";

interface ManualUrlFallbackProps {
  value: { url: string; branch: string };
  onChange: (v: { url: string; branch: string }) => void;
  onBack: () => void;
}

export function ManualUrlFallback({ value, onChange, onBack }: ManualUrlFallbackProps) {
  return (
    <div className="space-y-3 pt-1">
      <div className="grid grid-cols-[1fr_140px] gap-3">
        <div className="space-y-1.5">
          <Label htmlFor="manual-repo-url">
            Repository URL <span className="text-destructive">*</span>
          </Label>
          <div className="relative">
            <Github className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              id="manual-repo-url"
              placeholder="https://github.com/org/repo"
              value={value.url}
              onChange={(e) => onChange({ ...value, url: e.target.value })}
              className="pl-10"
            />
          </div>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="manual-branch">Branch</Label>
          <div className="relative">
            <GitBranch className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              id="manual-branch"
              placeholder="main"
              value={value.branch}
              onChange={(e) => onChange({ ...value, branch: e.target.value })}
              className="pl-10"
            />
          </div>
        </div>
      </div>
      <button
        type="button"
        onClick={onBack}
        className="text-xs text-muted-foreground hover:text-foreground underline-offset-2 hover:underline"
      >
        ← Browse connected repositories
      </button>
    </div>
  );
}
